import { useRef } from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import AnimatedOutlet from './AnimatedOutlet';
import AutoReveal from './AutoReveal';
import ScrollToTop from './ScrollToTop';
import TouchHover from './TouchHover';
import './Layout.css';

export default function Layout() {
  const mainRef = useRef(null);

  return (
    <div className="layout">
      <ScrollToTop />
      <TouchHover />
      <Navbar />
      <main className="layout-main" ref={mainRef}>
        <AutoReveal rootRef={mainRef} />
        <AnimatedOutlet />
      </main>
      <Footer />
    </div>
  );
}
